import { render, staticRenderFns } from "./CouponManage.vue?vue&type=template&id=12d1a513&scoped=true"
import script from "./CouponManage.vue?vue&type=script&lang=js"
export * from "./CouponManage.vue?vue&type=script&lang=js"
import style0 from "./CouponManage.vue?vue&type=style&index=0&id=12d1a513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d1a513",
  null
  
)

export default component.exports